module.exports = __webpack_public_path__ + "static/Q3Answer_foundingchildren2_wishmastree-0e2bcddae3c73aa71941cbad7cb015ad.jpg";